<template>
    <div :class="`course-type-${order.type}-detail`">
        <div class="course-date">
            <div
                class="pack-course"
                v-for="(course, index) in order.course.courses"
                :key="'pack-' + order.course.id + '-course-' + course.id"
            >
                <div class="summary-pack-course-name">{{ course.name }}</div>
                <div
                    class="summary-pack-course-date"
                    v-if="order.events.length"
                >
                    <span class="course-date-detail">
                        {{
                            mixins.methods.dateFullText(
                                order.events[index].start_datetime,
                                order.events[index].timezone,
                                course.is_online
                            )
                        }}
                    </span>
                    <span class="course-hours">
                        <span
                            v-html="
                                mixins.methods.hours(
                                    order.events[index].start_datetime,
                                    order.events[index].end_datetime,
                                    order.events[index].timezone,
                                    course.is_online
                                )
                            "
                        ></span>
                        <span class="text-muted" v-if="course.is_online"
                            >({{ this.app.locale.getUserTimezone() }})</span
                        >
                    </span>
                </div>
                <div class="course-binder">
                    <i class="fas fa-plus-circle"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CourseOrder from './../../../../../class/CourseOrder';

export default {
    props: {
        order: {
            type: CourseOrder,
            required: true,
        },
    },
};
</script>
